import HttpApi from 'i18next-http-backend';
import i18n from 'i18next';
import translations from './translations';
import { getCookie } from '../common/utils/cookies';
import { initReactI18next } from 'react-i18next';

const pathToLocales = 'locals';
const backend = {
  loadPath: `${pathToLocales}/en/{{ns}}.json`,
  addPath: `locals/add/{{lng}}/{{ns}}.json`,
};

const localePlayer = getCookie('locale_player') || 'EN_US';

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    lng: localePlayer.toLocaleLowerCase(),
    fallbackLng: 'en_us',
    backend,
    resources: translations,
    debug: process.env.NODE_ENV === 'development',
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false, // we use content as keys
    react: {
      wait: true,
    },
  });

export default i18n;
